import _ from 'lodash';
import HomeIcon from '@material-ui/icons/Home';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import { SET_FINANCES, SET_GLOBAL_FINANCES } from '../../actions/types/index';
import { ALL_ORDER_TYPES, CANCELED, REACTIVATION_BASKET, RETENTION, MISSED_REASONS, CANCELED_REASONS } from '../../constants'
import moment from 'moment';
export const getBottomNavigationData = data => {
  const newData = [];
  _.map(data, (e, key) => {
    newData.push({
      label: e,
      icon: key === 1 ? <AccountBalanceIcon /> : <HomeIcon />
    });
  });
  return newData;
};

export const getBottomNavigationComponentSize = numberOfItems => {
  let classNameBottomNavigation = 'col-sm-4 col-md-3 col-lg-2';
  if (numberOfItems > 1) {
    classNameBottomNavigation = 'col-sm-6 col-md-5 col-lg-4 col-xl-3';
  }
  return classNameBottomNavigation;
};

export const initializeFinance = async (isAllShops, component) => {
  const { dateRange } = component.state;
  component.setState({ isLoadingDate: true });
  if (isAllShops) {
    await component.props.setFinances(dateRange, SET_GLOBAL_FINANCES, component.props.shops, isAllShops);
    component.props.setSelectionFinanceEntity('global');
  } else {
    await component.props.setFinances(dateRange, SET_FINANCES, component.props.shops, isAllShops);
    component.props.setSelectionFinanceEntity('shop');
  }
  component.setState({ isLoading: false, isLoadingDate: false });
};

export const onChangeSelection = (component, e, value, valueTab) => {
  e.preventDefault();
  component.props.setSelectionFinance({ graph: value, tab: valueTab });
};

export const onChangeData = (component, e, value) => {
  e.preventDefault();
  component.props.setSelectionFinanceEntity(value ? 'global' : 'shop');
};

export const handleClick = (component, event) => {
  component.setState({ anchorEl: event.currentTarget });
};

export const handleClickYear = (component, event) => {
  component.setState({ anchorElYear: event.currentTarget });
};

export const handleClose = component => {
  component.setState(prevState => {
    return {
      anchorEl: null,
      periode: prevState.periode,
      anchorElYear: null,
      currentYear: prevState.currentYear
    };
  });
};

export const handleUpdateYear = (component, e) => {
  component.setState({
    currentYear: e,
    anchorElYear: null,
    periode: 'Selectionnez une période'
  });
};

export const onSelectDate = async (component, dateRange) => {
  component.setState({
    dateRange,
    isLoadingDate: true
  });
  await component.props.setFinances(dateRange, SET_FINANCES, component.props.shops, component.props.isAllShops);
  await component.props.setFinances(dateRange, SET_GLOBAL_FINANCES, component.props.shops, component.props.isAllShops);
  component.setState({
    dateRange,
    isLoadingDate: false
  });
};
const calculateCanceledOrMissedCommands = (billing, shopId, cancelReasons) => {
  return _.filter(billing,
    bill =>
      bill.shopId === shopId &&
      bill.status === CANCELED &&
      cancelReasons?.includes(bill.cancellation?.cancelReason)
  ).length;
};
const calculateOrderTypes = (shopBilling, orderType) => {
  return _.filter(shopBilling, bill => bill.orderType && bill.orderType === orderType).length || 0;
};

const calculateMarketingMethods = (shopBilling, marketingMethod) => {
  return _.filter(shopBilling, bill => bill.marketingMethod === marketingMethod).length || 0;
};


export const calculateTotalTabForShop = async (billing, shopBilling, previousPeriod, shopId) => {
  let totalShopTab = {}
  let CA = 0
  let nbCmd = 0
  let totalOrderTypes = {}
  ALL_ORDER_TYPES.forEach(orderType => {
    totalOrderTypes[orderType] = calculateOrderTypes(shopBilling, orderType);
  });
  shopBilling.forEach(({ priceOrder: price = 0 }) => {
    CA += price;
    nbCmd += 1;
  });
  const previousCA = await calculateCAThroughDateRange(billing, previousPeriod, shopId);
  const totalPreviousCA = await calculateCAThroughDateRange(billing, previousPeriod);
  const missedCmd = calculateCanceledOrMissedCommands(shopBilling, shopId, MISSED_REASONS);
  const canceledCmd = calculateCanceledOrMissedCommands(shopBilling, shopId, CANCELED_REASONS);
  totalShopTab = {
    CA,
    nbCmd,
    moy: nbCmd ? CA / nbCmd : 0,
    rate: previousCA ? (((CA - previousCA) / previousCA) * 100) : 0,
    previousCA,
    totalPreviousCA,
    totalOrderTypes,
    totalCmd: {
      nbCmd,
      canceledCmd,
      missedCmd,
      validateOrder: nbCmd - (canceledCmd + missedCmd),
    },
    reactivationBasket: calculateMarketingMethods(shopBilling, REACTIVATION_BASKET),
    retention: calculateMarketingMethods(shopBilling, RETENTION),
  }
  return totalShopTab;
};


export const calculateCost = (organize, tab, price, priceCost) => {
  organize.cumulDaily += price;
  tab[0].cost += price;
  tab[1].cost += priceCost;
  tab[3].cost += 1;
};

export const calculateCAThroughDateRange = async (billing, dateRange, shopId) => {
  let totalCA = 0;
  try {
    const firstDate = moment(dateRange.startDate);
    const lastDate = moment(dateRange.endDate);
    const groupedBilling = {};
    if (shopId) {
      billing?.forEach(bill => {
        if (!groupedBilling[bill.shopId]) {
          groupedBilling[bill.shopId] = [];
        }
        groupedBilling[bill.shopId].push(bill);
      });
    }
    const shopBilling = shopId ? groupedBilling[shopId] : billing;
    if (shopBilling) {
      shopBilling.forEach(commande => {
        const {
          priceOrder: price = 0,
          dateOrder: orderDate = '',
        } = commande;

        const orderDateMoment = moment(orderDate);
        if (orderDateMoment.isSameOrAfter(firstDate) &&
          orderDateMoment.isSameOrBefore(lastDate) &&
          price !== 0) {
          totalCA += price;
        }
      });
    }
  } catch (error) {
    console.error(error);
  }
  return totalCA;
}

export const calculatePreviousPeriod = (dateRange) => {
  const startDate = moment(dateRange.startDate).startOf('day');
  const endDate = moment(dateRange.endDate).endOf('day');

  const daysDifference = endDate.diff(startDate, 'days') + 1;

  const previousPeriodEndDate = startDate
    .clone()
    .subtract(1, 'day')
    .endOf('day');

  const previousPeriodStartDate = previousPeriodEndDate
    .clone()
    .subtract(daysDifference - 1, 'days')
    .startOf('day');

  return {
    startDate: previousPeriodStartDate.toDate(),
    endDate: previousPeriodEndDate.toDate(),
  };
};

export function calculateFinanceData(seedData, shopResults, numPage, rowsPerPage, shops, isAllShops) {
  const allTotalTabs = _.map(shopResults, result => result.totalShopTab);
  let total = 0;
  let totalCanceledCmd = 0;
  let totalMissedCmd = 0;
  let totalValidateOrder = 0;
  let totalClick_and_seat = 0;
  let totalClick_and_collect = 0;
  let totalDelivery = 0;
  let totalRetention = 0;
  let totalReactivationBasket = 0;
  const rowsCopy = [...allTotalTabs];
  if (isAllShops) {
    rowsCopy.forEach(({ totalPreviousCA, totalCmd = {}, totalOrderTypes = {}, retention = 0, reactivationBasket = 0 }) => {
      const { canceledCmd = 0, missedCmd = 0, validateOrder = 0 } = totalCmd;
      const { click_and_seat = 0, click_and_collect = 0, delivery = 0 } = totalOrderTypes;
      if (totalPreviousCA) {
        total = totalPreviousCA
      }
      totalCanceledCmd += canceledCmd
      totalMissedCmd += missedCmd;
      totalValidateOrder += validateOrder
      totalClick_and_seat += click_and_seat
      totalClick_and_collect += click_and_collect
      totalDelivery += delivery;
      totalRetention += retention;
      totalReactivationBasket += reactivationBasket
    });

    const totalCurrentCA = seedData[0]?.cost;
    const rate = total === 0 ? 0 : ((((totalCurrentCA - total) / total) * 100));
    rowsCopy.push({
      name: 'Total',
      moy: seedData[4]?.cost,
      totalCmd: {
        nbCmd: seedData[3]?.cost,
        missedCmd: totalMissedCmd,
        canceledCmd: totalCanceledCmd,
        validateOrder: totalValidateOrder
      },
      totalOrderTypes: {
        click_and_collect: totalClick_and_collect,
        delivery: totalDelivery,
        click_and_seat: totalClick_and_seat
      },
      rate: rate,
      CA: seedData[0]?.cost,
      retention: totalRetention,
      reactivationBasket: totalReactivationBasket,
      shopId: 'total'
    });
  }

  _.map(rowsCopy, e => {
    if (e.name !== 'Total') {
      e.name = shops[e.shopId]?.name || e.shopId;
    }
  }).slice(numPage * rowsPerPage, numPage * rowsPerPage + rowsPerPage);

  return rowsCopy;
}
